module.exports = __webpack_public_path__ + "img/NDZ.035d5336.svg";